import { useTranslation } from '@wix/wix-i18n-config';
import { ChatSmall } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useSelector, useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logMessageNotificationClickedAction } from '../../../bi';
import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import {
  selectIsUserEngaged,
  selectStartChatLoading,
  selectUnreadCount,
} from '../../../common/selectors/chat';
import { Page } from '../../../common/types';
import { appRoutes } from '../../../routes';
import { renderModel } from '../../../util/renderModel';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import { HeaderActionsIcon } from './HeaderActionsIcon';
import { MessageNotificationCounter } from './MessageNotificationCounter';
import s from './styles.scss';

const isChatbotDisabled = renderModel.isChatbotDisabled();

export const MessageNotification: FC = () => {
  const { t } = useTranslation();
  const store = useStore();
  const navigate = useNavigate();
  const startChatLoading = useSelector(selectStartChatLoading);
  const unreadCount = useSelector(selectUnreadCount);
  const isUserEngaged = useSelector(selectIsUserEngaged);
  const currentPage = useCurrentPage();

  const shouldShowButton = currentPage !== Page.Chatbot && isUserEngaged && !isChatbotDisabled;

  const openChatbot = useCallback(() => {
    const state = store.getState();

    logMessageNotificationClickedAction(state, {
      currentPage,
      clickedValue: unreadCount.toString(),
    });
    navigate(appRoutes.chatbot());
  }, [store, navigate, unreadCount, currentPage]);

  return shouldShowButton ? (
    <span className={s.messageNotification}>
      <HeaderActionsIcon
        onClick={openChatbot}
        dataHook={headerActionsDataHooks.newMessageNotificationIcon()}
        tooltipContent={t('header_action_icon_chat')}
      >
        <ChatSmall />
      </HeaderActionsIcon>
      {!startChatLoading && <MessageNotificationCounter />}
    </span>
  ) : null;
};
